import request from 'crm/utils/request'
import api from 'crm/common/api/grouping'

export async function getCustomerGrouping() {
    return request(api.getCustomerGrouping.url)
}

export async function getGroupGrouping() {
    return request(api.getGroupGrouping.url)
}
